import { IonSearchbar, ModalController, SearchbarCustomEvent } from '@ionic/angular';
import { Component, Input, Output, EventEmitter, inject, OnInit, ViewChild } from '@angular/core';

export class DialogButton {
  label: string;
  color: 'danger' | 'dark' | 'light' | 'medium' | 'primary' | 'secondary' | 'success' | 'tertiary' | 'warning';
  func: Function
}

@Component({
  selector: 'tcc-mono-dialog-layout',
  templateUrl: './dialog-layout.component.html',
  styleUrls: ['./dialog-layout.component.scss']
})
export class DialogLayoutComponent implements OnInit {
  private readonly _modalCtrl: ModalController = inject(ModalController);

  @Input() public toolbarColor: 'danger' | 'dark' | 'light' | 'medium' | 'primary' | 'secondary' | 'success' | 'tertiary' | 'warning' | string & Record<never, never> | undefined = 'primary';
  @Input() public title: string;
  @Input() public saveText: string;
  @Input() public buttons: DialogButton[] = [];
  @Input() public displayBottomButtons: boolean = true;
  //Only use this if the stacked-list-component is used
  @Input() public displayBottomButtonsFixedAndTransparent: boolean = false;
  @Input() public displaySearch: boolean = false;
  @Input() public focusOnSearch: boolean = false;
  @Input() public filterText: string;
  @Input() public searchDebounce: number = 300;
  @Input() public searchInputType: string = 'text';

  @Output() public onSave = new EventEmitter();
  @Output() public onSearch = new EventEmitter<string>();

  @ViewChild('searchbar') searchbar: IonSearchbar;

  public ngOnInit(): void {
    if (this.focusOnSearch) {
      setTimeout(() => {
        this.searchbar.setFocus();
      }, 100);
    }
  }

  public close(): void {
    this._modalCtrl.dismiss();
  }

  public save(): void {
    this.onSave.emit();
  }

  public search(event: any) {
    event = event as SearchbarCustomEvent;
    const value = event.target.value;
    this.onSearch.emit(value);
  }
}
